
const state = {
  showStatusBar: false,
  titleStatusbar: 'Importando arquivos - Será enviada para o o seu e-mail assim que concluída - Isso pode demorar alguns minutos',
  type: ''
}
const mutations = {
  'TOGGLE_STATUS_BAR' (state, payload = false) {
    state.showStatusBar = !!payload
  },
  'SET_TITLE_BAR' (state, payload) {
    state.titleStatusbar = payload
  },
  'SET_TYPE_BAR' (state, payload) {
    state.type = payload
  }
}

const actions = {
  toggleStatusBar ({ commit }) {
    commit('TOGGLE_STATUS_BAR', true)
  },
  setTitleBar ({ commit } , payload) {
    commit('SET_TITLE_BAR', payload)
  },
  setIconBar ({ commit } , payload) {
    commit('SET_TYPE_BAR', payload)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
